import React from 'react';
import {Grid} from '@mui/material';
import {makeStyles} from "@mui/styles";
import ChartContents from "./ChartContents";
import "react-datepicker/dist/react-datepicker.css";
import {Body, colorLabel} from "../index";

const useStyles = makeStyles(() => ({
  box: {
    height: 276,
    borderRadius: 6,
    marginBottom: 16,
    padding: 40,
    overflow: "hidden",
    backgroundColor: "#FFFFFF",
    border: "1px solid rgba(242,243,251)",
  },
  bullet: {
    width: 8,
    height: 8,
    marginTop: 6,
    marginRight: 6,
    borderRadius: 50,
    backgroundColor: "#d3d3d3"
  },
  comment: {
    color: colorLabel,
  }
}));

const totalMonthCount = (data: []) => {
  if (data === undefined) {
    return 0;
  }

  let totalCount :number = 0;
  data.map((v:any) => totalCount += v.count);
  return totalCount;
}

const totalMonthCharge = (data: []) => {
  if (data === undefined) {
    return 0;
  }

  let totalCharge :number = 0;
  data.map((v:any) => totalCharge += v.charge);
  return totalCharge;
}

export default function Charts(props: any) {
  const classes = useStyles();

  return (
    <>
      <Grid container direction={"column"}>
        <Grid item className={classes.box}>
          <ChartContents
            title={"이번 달 운송건수"}
            countBoxTitle={"총 운송건수"}
            standard={"건"}
            type={"count"}
            data={props.dashboard.data}
            totalValue={totalMonthCount(props.dashboard.data)}
            chartName={"monthCount"}
          />
        </Grid>
        <Grid item className={classes.box}>
          <ChartContents
            title={"이번 달 운송비"}
            countBoxTitle={"총 운송비"}
            standard={"원"}
            type={"charge"}
            data={props.dashboard.data}
            totalValue={totalMonthCharge(props.dashboard.data)}
            chartName={"monthPrice"}
          />
        </Grid>
        <Grid item>
          <Grid container direction={"row"} justifyContent={"flex-end"}>
            <Grid item>
              <div className={classes.bullet}/>
            </Grid>
            <Grid item>
              <Body className={classes.comment}>출발날짜/시간 기준입니다.</Body>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}